export const enabledCalendarNotifications = (config) => {
    return Boolean((config.notificationsHelper)  || config.oneSignalAppId);
}

export const downloadCalendar = (url, format) => {
    fetch(url, { headers: { 'Accept': format }})
        .then(response => {
            const promise = new Promise((resolve, reject) =>
                response.blob()
                    .then(blob => resolve({ filename: getAttachmentFileName(response), blob }))
            )
            return promise
        })
        .then(({ filename, blob }) => {
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
        }).catch(err => {
            console.error('Could not download the iCalendar file')
            console.error(err)
        })
}

const getAttachmentFileName = (response) => {
    let filename = null
    const disposition = response.headers.get('Content-Disposition')
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        var matches = filenameRegex.exec(disposition)
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
        }
    }
    return filename
}

